import { render } from "./appmessage.vue?vue&type=template&id=6462c647&scoped=true"
import script from "./appmessage.vue?vue&type=script&lang=js"
export * from "./appmessage.vue?vue&type=script&lang=js"

import "./appmessage.vue?vue&type=style&index=0&id=6462c647&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6462c647"]])

export default __exports__